var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.isVisible
    ? _c(
        "b-container",
        { attrs: { id: "conciliacion", fluid: "" } },
        [
          _c(
            "b-row",
            [
              _c("b-col", { attrs: { md: "12" } }, [
                _c("h4", { staticClass: "title mt-4 mb-4" }, [
                  _vm._v(
                    "\n        " +
                      _vm._s(
                        _vm.$t(
                          "apeironGwApp.conciliacionExtranjeras.title-guia-formalizacion"
                        )
                      ) +
                      "\n      "
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c(
                "b-col",
                { staticClass: "mb-5" },
                [
                  _c("message", {
                    staticStyle: { "white-space": "pre-line" },
                    attrs: {
                      description: _vm.$t("apeironGwApp.guia.decripcion"),
                      variant: "info",
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        [
                          _vm.issste
                            ? _c(
                                "b-link",
                                {
                                  attrs: {
                                    href: _vm.guiaISSSTE,
                                    target: "_blank",
                                  },
                                },
                                [
                                  _c(
                                    "b-button",
                                    {
                                      staticClass: "btn btn-primary",
                                      attrs: {
                                        type: "button",
                                        id: "id-guia-issste",
                                      },
                                    },
                                    [
                                      _c("span", {
                                        domProps: {
                                          textContent: _vm._s(
                                            _vm.$t("apeironGwApp.guia.descarga")
                                          ),
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c("span", {
                                        staticClass: "icon-descargar",
                                      }),
                                    ]
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.isApoyos
                            ? _c(
                                "b-link",
                                {
                                  attrs: {
                                    href: _vm.guiaApoyos,
                                    target: "_blank",
                                  },
                                },
                                [
                                  _c(
                                    "b-button",
                                    {
                                      staticClass: "btn btn-primary",
                                      attrs: {
                                        type: "button",
                                        id: "id-guia-apoyos",
                                      },
                                    },
                                    [
                                      _c("span", {
                                        domProps: {
                                          textContent: _vm._s(
                                            _vm.$t("apeironGwApp.guia.descarga")
                                          ),
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c("span", {
                                        staticClass: "icon-descargar",
                                      }),
                                    ]
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.isGeneral
                            ? _c(
                                "b-link",
                                {
                                  attrs: {
                                    href: _vm.guiaGeneral,
                                    target: "_blank",
                                  },
                                },
                                [
                                  _c(
                                    "b-button",
                                    {
                                      staticClass: "btn btn-primary",
                                      attrs: { type: "button", id: "id-guia" },
                                    },
                                    [
                                      _c("span", {
                                        domProps: {
                                          textContent: _vm._s(
                                            _vm.$t("apeironGwApp.guia.descarga")
                                          ),
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c("span", {
                                        staticClass: "icon-descargar",
                                      }),
                                    ]
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c("b-col", { attrs: { md: "12" } }, [
                _c("h4", { staticClass: "title mt-4 mb-4" }, [
                  _vm._v(
                    "\n        " +
                      _vm._s(
                        _vm.$t(
                          "apeironGwApp.conciliacionExtranjeras.title-apoyos"
                        )
                      ) +
                      "\n      "
                  ),
                ]),
              ]),
              _vm._v(" "),
              _vm.solucion.params.tipoBecaExtranjero === "CIENCIAS_HUMANIDADES"
                ? _c(
                    "b-col",
                    { attrs: { md: "6" } },
                    [
                      _c(
                        "b-form-group",
                        {
                          attrs: {
                            label: _vm.$t(
                              "apeironGwApp.conciliacionExtranjeras.title-tipo-beca-obtener"
                            ),
                          },
                        },
                        [
                          _c("b-form-input", {
                            attrs: { readonly: true },
                            model: {
                              value:
                                _vm.solicitud.SOLICITUD_RIZOMA.apoyo.tipoBeca
                                  .descripcion,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.solicitud.SOLICITUD_RIZOMA.apoyo.tipoBeca,
                                  "descripcion",
                                  $$v
                                )
                              },
                              expression:
                                "solicitud.SOLICITUD_RIZOMA.apoyo.tipoBeca.descripcion",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "b-col",
                { attrs: { md: "6" } },
                [
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        label: _vm.$t(
                          "apeironGwApp.conciliacionExtranjeras.apoyo.apoyo-obtener"
                        ),
                      },
                    },
                    [
                      _c("b-form-input", {
                        attrs: { readonly: true },
                        model: {
                          value:
                            _vm.solicitud.SOLICITUD_RIZOMA.apoyo.tipoApoyo
                              .nombre,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.solicitud.SOLICITUD_RIZOMA.apoyo.tipoApoyo,
                              "nombre",
                              $$v
                            )
                          },
                          expression:
                            "solicitud.SOLICITUD_RIZOMA.apoyo.tipoApoyo.nombre",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-col",
                { attrs: { md: "6" } },
                [
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        label: _vm.$t(
                          "apeironGwApp.conciliacionExtranjeras.apoyo.pais"
                        ),
                      },
                    },
                    [
                      _c("b-form-input", {
                        attrs: { readonly: true },
                        model: {
                          value:
                            _vm.solicitud.SOLICITUD_RIZOMA.apoyo.pais.nombre,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.solicitud.SOLICITUD_RIZOMA.apoyo.pais,
                              "nombre",
                              $$v
                            )
                          },
                          expression:
                            "solicitud.SOLICITUD_RIZOMA.apoyo.pais.nombre",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-col",
                { attrs: { md: "12" } },
                [
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        label: _vm.$t(
                          "apeironGwApp.conciliacionExtranjeras.apoyo.institucion"
                        ),
                      },
                    },
                    [
                      _c("b-form-input", {
                        attrs: { readonly: true },
                        model: {
                          value:
                            _vm.solicitud.SOLICITUD_RIZOMA.apoyo.institucion
                              .nombre,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.solicitud.SOLICITUD_RIZOMA.apoyo.institucion,
                              "nombre",
                              $$v
                            )
                          },
                          expression:
                            "solicitud.SOLICITUD_RIZOMA.apoyo.institucion.nombre",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-col",
                { attrs: { md: "12" } },
                [
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        label: _vm.$t(
                          "apeironGwApp.conciliacionExtranjeras.apoyo.programa"
                        ),
                      },
                    },
                    [
                      _c("b-form-input", {
                        attrs: { readonly: true },
                        model: {
                          value: _vm.solicitud.SOLICITUD_RIZOMA.apoyo.programa,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.solicitud.SOLICITUD_RIZOMA.apoyo,
                              "programa",
                              $$v
                            )
                          },
                          expression:
                            "solicitud.SOLICITUD_RIZOMA.apoyo.programa",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-row",
            [
              _c("b-col", { attrs: { md: "12" } }, [
                _c("h4", { staticClass: "title mt-4 mb-4" }, [
                  _vm._v(
                    "\n        " +
                      _vm._s(
                        _vm.$t(
                          "apeironGwApp.conciliacionExtranjeras.title-apoyos-autorizar"
                        )
                      ) +
                      "\n      "
                  ),
                ]),
              ]),
              _vm._v(" "),
              _vm.solucion.params.tipoBecaExtranjero === "CIENCIAS_HUMANIDADES"
                ? _c(
                    "b-col",
                    { attrs: { md: "12" } },
                    [
                      _c(
                        "b-form-group",
                        { attrs: { label: "Tipo de beca" } },
                        [
                          _c(
                            "b-form-select",
                            {
                              attrs: {
                                id: "tipo-beca-select",
                                disabled:
                                  !_vm.isJefeDepartamento || _vm.readOnly,
                              },
                              model: {
                                value:
                                  _vm.solicitud.datos_conciliados.apoyo
                                    .tipoBeca,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.solicitud.datos_conciliados.apoyo,
                                    "tipoBeca",
                                    $$v
                                  )
                                },
                                expression:
                                  "solicitud.datos_conciliados.apoyo.tipoBeca",
                              },
                            },
                            [
                              _c(
                                "b-form-select-option",
                                { attrs: { value: null } },
                                [_vm._v("-- Seleccione --")]
                              ),
                              _vm._v(" "),
                              _vm._l(
                                _vm.solucion.params.tipoBeca,
                                function (tipo) {
                                  return _c(
                                    "b-form-select-option",
                                    { key: tipo.tipo, attrs: { value: tipo } },
                                    [
                                      _vm._v(
                                        "\n            " +
                                          _vm._s(tipo.descripcion) +
                                          "\n          "
                                      ),
                                    ]
                                  )
                                }
                              ),
                            ],
                            2
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "b-col",
                { attrs: { md: "6" } },
                [
                  _c("input-select-one", {
                    attrs: {
                      id: "apoyo-tipo-apoyo-nombre",
                      label: _vm.$t(
                        "apeironGwApp.conciliacionExtranjeras.form.apoyo.label"
                      ),
                      readonly: true,
                      required: true,
                      options: _vm.catApoyoObtener,
                      valid: _vm.$v.solicitud.datos_conciliados.apoyo.tipoApoyo
                        .$dirty
                        ? !_vm.$v.solicitud.datos_conciliados.apoyo.tipoApoyo
                            .$error
                        : null,
                      validationsCommons: {
                        requiredValue:
                          !_vm.$v.solicitud.datos_conciliados.apoyo.tipoApoyo
                            .required,
                        requiredMessage: _vm.$t(
                          "apeironGwApp.conciliacionExtranjeras.form.apoyo.validations.required"
                        ),
                        regexMessage: _vm.$t(
                          "apeironGwApp.conciliacionExtranjeras.form.apoyo.validations.regexMessage"
                        ),
                      },
                    },
                    model: {
                      value:
                        _vm.$v.solicitud.datos_conciliados.apoyo.tipoApoyo
                          .$model,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.$v.solicitud.datos_conciliados.apoyo.tipoApoyo,
                          "$model",
                          $$v
                        )
                      },
                      expression:
                        "$v.solicitud.datos_conciliados.apoyo.tipoApoyo.$model",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-col",
                { attrs: { md: "6" } },
                [
                  _c("input-select-one", {
                    attrs: {
                      id: "apoyo-tipo-apoyo-pais",
                      label: _vm.$t(
                        "apeironGwApp.conciliacionExtranjeras.form.pais.label"
                      ),
                      readonly: true,
                      required: true,
                      options: _vm.catPais,
                      valid: _vm.$v.solicitud.datos_conciliados.apoyo.pais
                        .$dirty
                        ? !_vm.$v.solicitud.datos_conciliados.apoyo.pais.$error
                        : null,
                      validationsCommons: {
                        requiredValue:
                          !_vm.$v.solicitud.datos_conciliados.apoyo.pais
                            .required,
                        requiredMessage: _vm.$t(
                          "apeironGwApp.conciliacionExtranjeras.form.pais.validations.required"
                        ),
                        regexMessage: _vm.$t(
                          "apeironGwApp.conciliacionExtranjeras.form.pais.validations.regexMessage"
                        ),
                      },
                    },
                    model: {
                      value:
                        _vm.$v.solicitud.datos_conciliados.apoyo.pais.$model,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.$v.solicitud.datos_conciliados.apoyo.pais,
                          "$model",
                          $$v
                        )
                      },
                      expression:
                        "$v.solicitud.datos_conciliados.apoyo.pais.$model",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-col",
                { attrs: { md: "12" } },
                [
                  _c("input-select-one", {
                    attrs: {
                      id: "apoyo-tipo-apoyo-institucion",
                      label: _vm.$t(
                        "apeironGwApp.conciliacionExtranjeras.form.institucion.label"
                      ),
                      readonly: !_vm.isOperador || _vm.readOnly,
                      required: true,
                      options: _vm.catInstituciones,
                      valid: _vm.$v.solicitud.datos_conciliados.apoyo
                        .institucion.$dirty
                        ? !_vm.$v.solicitud.datos_conciliados.apoyo.institucion
                            .$error
                        : null,
                      validationsCommons: {
                        requiredValue:
                          !_vm.$v.solicitud.datos_conciliados.apoyo.institucion
                            .required,
                        requiredMessage: _vm.$t(
                          "apeironGwApp.conciliacionExtranjeras.form.institucion.validations.required"
                        ),
                        regexMessage: _vm.$t(
                          "apeironGwApp.conciliacionExtranjeras.form.institucion.validations.regexMessage"
                        ),
                      },
                    },
                    on: { change: _vm.changeConvenio },
                    model: {
                      value:
                        _vm.$v.solicitud.datos_conciliados.apoyo.institucion
                          .$model,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.$v.solicitud.datos_conciliados.apoyo.institucion,
                          "$model",
                          $$v
                        )
                      },
                      expression:
                        "$v.solicitud.datos_conciliados.apoyo.institucion.$model",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _vm.solucion.params.tipoBecaExtranjero !==
              "ESTANCIA_TECNICA_JAPON"
                ? _c(
                    "b-col",
                    { attrs: { md: "12" } },
                    [
                      _c("input-text", {
                        attrs: {
                          id: "apoyo-programa-id",
                          label: _vm.$t(
                            "apeironGwApp.conciliacionExtranjeras.form.programa.label"
                          ),
                          readonly: !_vm.isOperador || _vm.readOnly,
                          required: true,
                          valid: _vm.$v.solicitud.datos_conciliados.apoyo
                            .programa.$dirty
                            ? !_vm.$v.solicitud.datos_conciliados.apoyo.programa
                                .$error
                            : null,
                          validationsCommons: {
                            requiredValue:
                              !_vm.$v.solicitud.datos_conciliados.apoyo.programa
                                .required,
                            requiredMessage: _vm.$t(
                              "apeironGwApp.conciliacionExtranjeras.form.programa.validations.required"
                            ),
                          },
                        },
                        model: {
                          value:
                            _vm.$v.solicitud.datos_conciliados.apoyo.programa
                              .$model,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.$v.solicitud.datos_conciliados.apoyo.programa,
                              "$model",
                              $$v
                            )
                          },
                          expression:
                            "$v.solicitud.datos_conciliados.apoyo.programa.$model",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.solucion.params.tipoBecaExtranjero == "ESTANCIA_TECNICA_JAPON"
                ? _c(
                    "b-col",
                    { attrs: { md: "12" } },
                    [
                      _c("input-select-one", {
                        attrs: {
                          id: "apoyo-programa-id",
                          label: _vm.$t(
                            "apeironGwApp.conciliacionExtranjeras.form.programa.label"
                          ),
                          options: _vm.catPrograma,
                          readonly: true,
                          required: true,
                          valid: _vm.$v.solicitud.datos_conciliados.apoyo
                            .programa.$dirty
                            ? !_vm.$v.solicitud.datos_conciliados.apoyo.programa
                                .$error
                            : null,
                          validationsCommons: {
                            requiredValue:
                              !_vm.$v.solicitud.datos_conciliados.apoyo.programa
                                .required,
                            requiredMessage: _vm.$t(
                              "apeironGwApp.conciliacionExtranjeras.form.programa.validations.required"
                            ),
                          },
                        },
                        model: {
                          value:
                            _vm.$v.solicitud.datos_conciliados.apoyo.programa
                              .$model,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.$v.solicitud.datos_conciliados.apoyo.programa,
                              "$model",
                              $$v
                            )
                          },
                          expression:
                            "$v.solicitud.datos_conciliados.apoyo.programa.$model",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-row",
            [
              _c("b-col", { attrs: { md: "12" } }, [
                _c("h4", { staticClass: "title mt-4 mb-4" }, [
                  _vm._v(
                    "\n        " +
                      _vm._s(
                        _vm.$t(
                          "apeironGwApp.conciliacionExtranjeras.title-convenios"
                        )
                      ) +
                      "\n      "
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c(
                "b-col",
                { attrs: { cols: "12", sm: "6", md: "6", lg: "4" } },
                [
                  _c("b-form-checkbox", {
                    attrs: {
                      id: "isConvenio",
                      name: "check-isConvenio",
                      required: true,
                      disabled: !_vm.isOperador || _vm.readOnly,
                      switch: "",
                    },
                    on: { change: _vm.convenioOnly },
                    model: {
                      value: _vm.solicitud.isColaboracion,
                      callback: function ($$v) {
                        _vm.$set(_vm.solicitud, "isColaboracion", $$v)
                      },
                      expression: "solicitud.isColaboracion",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _vm.showConvenios || _vm.solicitud.isColaboracion
                ? _c(
                    "b-col",
                    { attrs: { md: "12" } },
                    [
                      _c("input-select-one", {
                        attrs: {
                          id: "apoyo-convenio-colaboracion",
                          label: _vm.$t(
                            "apeironGwApp.conciliacionExtranjeras.colaboracion"
                          ),
                          readonly: !_vm.isOperador || _vm.readOnly,
                          required: true,
                          options: _vm.opcionesConvenios,
                        },
                        model: {
                          value: _vm.solicitud.convenioColaboracion,
                          callback: function ($$v) {
                            _vm.$set(_vm.solicitud, "convenioColaboracion", $$v)
                          },
                          expression: "solicitud.convenioColaboracion",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-row",
            [
              _c("b-col", { attrs: { md: "12" } }, [
                _c("h4", { staticClass: "title mt-4 mb-4" }, [
                  _vm._v(
                    "\n        " +
                      _vm._s(
                        _vm.$t(
                          "apeironGwApp.conciliacionExtranjeras.title-periodos"
                        )
                      ) +
                      "\n      "
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c("b-col", { attrs: { md: "4" } }, [
                _c("div", { staticClass: "form-dg" }, [
                  _c("span", [
                    _vm._v(
                      _vm._s(
                        _vm.$t(
                          "apeironGwApp.conciliacionExtranjeras.periodos.inicio-estudios"
                        )
                      )
                    ),
                  ]),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v(
                      _vm._s(
                        _vm._f("formatUtc")(
                          _vm.solicitud.SOLICITUD_RIZOMA.periodo
                            .fechaInicioEstudios
                        )
                      )
                    ),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              _c("b-col", { attrs: { md: "4" } }, [
                _c("div", { staticClass: "form-dg" }, [
                  _c("span", [
                    _vm._v(
                      _vm._s(
                        _vm.$t(
                          "apeironGwApp.conciliacionExtranjeras.periodos.fin-estudios"
                        )
                      )
                    ),
                  ]),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v(
                      _vm._s(
                        _vm._f("formatUtc")(
                          _vm.solicitud.SOLICITUD_RIZOMA.periodo
                            .fechaFinEstudios
                        )
                      )
                    ),
                  ]),
                ]),
              ]),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-row",
            [
              _c("b-col", { attrs: { md: "4" } }, [
                _c("div", { staticClass: "form-dg" }, [
                  _c("span", [
                    _vm._v(
                      _vm._s(
                        _vm.$t(
                          "apeironGwApp.conciliacionExtranjeras.periodos.inicio-beca"
                        )
                      )
                    ),
                  ]),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v(
                      _vm._s(
                        _vm._f("formatUtc")(
                          _vm.solicitud.SOLICITUD_RIZOMA.periodo.fechaInicioBeca
                        )
                      )
                    ),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              _c("b-col", { attrs: { md: "4" } }, [
                _c("div", { staticClass: "form-dg" }, [
                  _c("span", [
                    _vm._v(
                      _vm._s(
                        _vm.$t(
                          "apeironGwApp.conciliacionExtranjeras.periodos.fin-beca"
                        )
                      )
                    ),
                  ]),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v(
                      _vm._s(
                        _vm._f("formatUtc")(
                          _vm.solicitud.SOLICITUD_RIZOMA.periodo.fechaFinBeca
                        )
                      )
                    ),
                  ]),
                ]),
              ]),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-row",
            [
              _c(
                "b-col",
                { attrs: { md: "12" } },
                [
                  _c("h4", { staticClass: "title mt-4 mb-4" }, [
                    _vm._v(
                      "\n        " +
                        _vm._s(
                          _vm.$t(
                            "apeironGwApp.conciliacionExtranjeras.title-periodos-autorizar"
                          )
                        ) +
                        "\n      "
                    ),
                  ]),
                  _vm._v(" "),
                  _vm.inicioMaximoBecaBandera
                    ? _c(
                        "b-alert",
                        {
                          staticClass: "mb-5",
                          attrs: { show: "", variant: "danger" },
                        },
                        [
                          _c("span", {
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.$t(
                                  "apeironGwApp.conciliacionExtranjeras.form.periodos-bext-hum.no-asigna-beca",
                                  { fecha: _vm.formatMesLong }
                                )
                              ),
                            },
                          }),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.fechaInicioMayorAFinBandera
                    ? _c(
                        "b-alert",
                        {
                          staticClass: "mb-5",
                          attrs: { show: "", variant: "danger" },
                        },
                        [
                          _c("span", {
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.$t(
                                  "apeironGwApp.conciliacionExtranjeras.form.periodos-bext-hum.inicio-mayor-fin",
                                  { fecha: _vm.formatMesLong }
                                )
                              ),
                            },
                          }),
                        ]
                      )
                    : _vm._e(),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-col",
                { attrs: { md: "4" } },
                [
                  _c("input-date-time", {
                    attrs: {
                      id: "inicio-estudios-id",
                      label: _vm.$t(
                        "apeironGwApp.conciliacionExtranjeras.form.inicio-estudios.label"
                      ),
                      disabled: !_vm.isOperador || _vm.readOnly,
                      required: true,
                      valid: _vm.$v.solicitud.datos_conciliados.periodo
                        .fechaInicioEstudios.$dirty
                        ? !_vm.$v.solicitud.datos_conciliados.periodo
                            .fechaInicioEstudios.$error
                        : null,
                      validationsCommons: {
                        requiredValue:
                          !_vm.$v.solicitud.datos_conciliados.periodo
                            .fechaInicioEstudios.required,
                        requiredMessage: _vm.$t(
                          "apeironGwApp.conciliacionExtranjeras.form.inicio-estudios.validations.required"
                        ),
                      },
                    },
                    on: { change: _vm.setInicioBeca },
                    model: {
                      value:
                        _vm.$v.solicitud.datos_conciliados.periodo
                          .fechaInicioEstudios.$model,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.$v.solicitud.datos_conciliados.periodo
                            .fechaInicioEstudios,
                          "$model",
                          $$v
                        )
                      },
                      expression:
                        "$v.solicitud.datos_conciliados.periodo.fechaInicioEstudios.$model",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-col",
                { attrs: { md: "4" } },
                [
                  _c("input-date-time", {
                    attrs: {
                      id: "fin-estudios-id",
                      label: _vm.$t(
                        "apeironGwApp.conciliacionExtranjeras.form.fin-estudios.label"
                      ),
                      disabled: !_vm.isOperador || _vm.readOnly,
                      starMonth: _vm.obtenerMesAnio(_vm.inicioMinimoBeca, "MM"),
                      required: true,
                      valid: _vm.$v.solicitud.datos_conciliados.periodo
                        .fechaFinEstudios.$dirty
                        ? !_vm.$v.solicitud.datos_conciliados.periodo
                            .fechaFinEstudios.$error
                        : null,
                      validationsCommons: {
                        requiredValue:
                          !_vm.$v.solicitud.datos_conciliados.periodo
                            .fechaFinEstudios.required,
                        requiredMessage: _vm.$t(
                          "apeironGwApp.conciliacionExtranjeras.form.fin-estudios.validations.required"
                        ),
                      },
                    },
                    on: { change: _vm.setFinBeca },
                    model: {
                      value:
                        _vm.$v.solicitud.datos_conciliados.periodo
                          .fechaFinEstudios.$model,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.$v.solicitud.datos_conciliados.periodo
                            .fechaFinEstudios,
                          "$model",
                          $$v
                        )
                      },
                      expression:
                        "$v.solicitud.datos_conciliados.periodo.fechaFinEstudios.$model",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-row",
            [
              _c(
                "b-col",
                { attrs: { md: "4" } },
                [
                  _c("input-date-time", {
                    attrs: {
                      id: "inicio-beca-id",
                      label: _vm.$t(
                        "apeironGwApp.conciliacionExtranjeras.periodos.inicio-beca"
                      ),
                      disabled: true,
                      required: true,
                      valid: _vm.$v.solicitud.datos_conciliados.periodo
                        .fechaInicioBeca.$dirty
                        ? !_vm.$v.solicitud.datos_conciliados.periodo
                            .fechaInicioBeca.$error
                        : null,
                      validationsCommons: {
                        requiredValue:
                          !_vm.$v.solicitud.datos_conciliados.periodo
                            .fechaInicioBeca.required,
                        requiredMessage: _vm.$t(
                          "apeironGwApp.conciliacionExtranjeras.periodos.inicio-estudios.validations.required"
                        ),
                      },
                    },
                    model: {
                      value:
                        _vm.$v.solicitud.datos_conciliados.periodo
                          .fechaInicioBeca.$model,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.$v.solicitud.datos_conciliados.periodo
                            .fechaInicioBeca,
                          "$model",
                          $$v
                        )
                      },
                      expression:
                        "$v.solicitud.datos_conciliados.periodo.fechaInicioBeca.$model",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-col",
                { attrs: { md: "4" } },
                [
                  _c("input-date-time", {
                    attrs: {
                      id: "fin-beca-id",
                      label: _vm.$t(
                        "apeironGwApp.conciliacionExtranjeras.periodos.fin-beca"
                      ),
                      disabled: true,
                      required: true,
                      valid: _vm.$v.solicitud.datos_conciliados.periodo
                        .fechaFinBeca.$dirty
                        ? !_vm.$v.solicitud.datos_conciliados.periodo
                            .fechaFinBeca.$error
                        : null,
                      validationsCommons: {
                        requiredValue:
                          !_vm.$v.solicitud.datos_conciliados.periodo
                            .fechaFinBeca.required,
                        requiredMessage: _vm.$t(
                          "datos-evaluacion.form.fin-beca.validations.required"
                        ),
                      },
                    },
                    model: {
                      value:
                        _vm.$v.solicitud.datos_conciliados.periodo.fechaFinBeca
                          .$model,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.$v.solicitud.datos_conciliados.periodo
                            .fechaFinBeca,
                          "$model",
                          $$v
                        )
                      },
                      expression:
                        "$v.solicitud.datos_conciliados.periodo.fechaFinBeca.$model",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _vm.$v.solicitud.datos_conciliados.apoyo.tipoApoyo.$model
                ? [
                    _c(
                      "b-col",
                      { attrs: { md: "8" } },
                      [
                        _c("input-text", {
                          attrs: {
                            id: "meses-solicitados-beca-id",
                            label: _vm.$t(
                              "apeironGwApp.conciliacionExtranjeras.form.meses-solicitados-beca.label"
                            ),
                            readonly: true,
                          },
                          model: {
                            value:
                              _vm.$v.solicitud.datos_conciliados.periodo
                                .duracionBeca.$model,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.$v.solicitud.datos_conciliados.periodo
                                  .duracionBeca,
                                "$model",
                                $$v
                              )
                            },
                            expression:
                              "$v.solicitud.datos_conciliados.periodo.duracionBeca.$model",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.solucion.params.tipoBecaExtranjero !==
                    "ESPECIALIDADES_MEDICAS"
                      ? _c(
                          "b-col",
                          { attrs: { md: "12" } },
                          [
                            _c("input-text", {
                              attrs: {
                                id: "duracion-meses-beca-id",
                                label: _vm.$t(
                                  "apeironGwApp.conciliacionExtranjeras.form.duracion-maxima-meses.label"
                                ),
                                readonly: true,
                                description: _vm.$t(
                                  "apeironGwApp.conciliacionExtranjeras.form.duracion-maxima-meses.description",
                                  {
                                    tipoApoyo:
                                      _vm.$v.solicitud.datos_conciliados.apoyo
                                        .tipoApoyo.$model.nombre,
                                  }
                                ),
                              },
                              model: {
                                value: _vm.duracionMeses,
                                callback: function ($$v) {
                                  _vm.duracionMeses = $$v
                                },
                                expression: "duracionMeses",
                              },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                  ]
                : _vm._e(),
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "b-row",
            [_c("b-col", [_c("div", { staticClass: "border-custom" })])],
            1
          ),
          _vm._v(" "),
          _vm.solicitud.datos_conciliados.rubros.length > 0
            ? _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { attrs: { md: "12" } },
                    [
                      _c("h4", { staticClass: "title mt-4 mb-4" }, [
                        _vm._v(
                          "\n        " +
                            _vm._s(
                              _vm.$t(
                                "apeironGwApp.conciliacionExtranjeras.title-rubros"
                              )
                            ) +
                            "\n      "
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "b-card",
                        { staticClass: "mb-3" },
                        [
                          _c(
                            "b-row",
                            _vm._l(
                              _vm.solicitud.datos_conciliados.rubros,
                              function (item) {
                                return _c(
                                  "b-col",
                                  { key: item.id, attrs: { md: "4" } },
                                  [
                                    _c("b-card-text", [
                                      _c(
                                        "div",
                                        { staticClass: "font-weight-bolder" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.getNombreRubro(item.concepto)
                                            )
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("div", [
                                        _vm._v(
                                          _vm._s(item.periodo) +
                                            " / " +
                                            _vm._s(item.moneda) +
                                            " / " +
                                            _vm._s(item.montoTotal)
                                        ),
                                      ]),
                                    ]),
                                  ],
                                  1
                                )
                              }
                            ),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value:
                            !_vm.readOnly &&
                            _vm.solucion.params.tipoBecaExtranjero !==
                              "ESTANCIA_TECNICA_JAPON" &&
                            _vm.solucion.params.tipoBecaExtranjero !==
                              "CONVENIO_ISSSTE",
                          expression:
                            "\n        !readOnly &&\n        solucion.params.tipoBecaExtranjero !== 'ESTANCIA_TECNICA_JAPON' &&\n        solucion.params.tipoBecaExtranjero !== 'CONVENIO_ISSSTE'\n      ",
                        },
                      ],
                      attrs: { md: "12" },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "float-right mt-4" },
                        [
                          _vm.isOperador
                            ? _c(
                                "b-button",
                                {
                                  attrs: { variant: "primary" },
                                  on: { click: _vm.rubrosPeriodo },
                                },
                                [
                                  _c("span", {
                                    domProps: {
                                      textContent: _vm._s(
                                        _vm.$t(
                                          "apeironGwApp.conciliacionExtranjeras.recalcular"
                                        )
                                      ),
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("font-awesome-icon", {
                                    staticClass: "mr-2",
                                    attrs: { icon: "save" },
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _vm.solucion.params.tipoBecaExtranjero !==
                  "ESTANCIA_TECNICA_JAPON"
                    ? _c(
                        "b-col",
                        { attrs: { md: "12" } },
                        [
                          _c("h4", { staticClass: "title mt-4 mb-4" }, [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "apeironGwApp.conciliacionExtranjeras.title-rubros-autorizar"
                                )
                              )
                            ),
                          ]),
                          _vm._v(" "),
                          _c("b-table", {
                            ref: "tableRubros",
                            staticClass: "table-conciliacion",
                            attrs: {
                              striped: "",
                              hover: "",
                              fields: _vm.fields,
                              items: _vm.solicitud.datos_conciliados.rubros,
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "cell()",
                                  fn: function (data) {
                                    return [
                                      _vm._v(
                                        "\n          " +
                                          _vm._s(
                                            _vm.getNombreRubro(
                                              data.item.concepto
                                            )
                                          ) +
                                          " " +
                                          _vm._s(
                                            _vm.$t(
                                              "apeironGwApp.conciliacionExtranjeras.rubros.anual"
                                            )
                                          ) +
                                          " " +
                                          _vm._s(data.item.divisa) +
                                          "\n        "
                                      ),
                                    ]
                                  },
                                },
                                {
                                  key: "cell(anio_1)",
                                  fn: function (data) {
                                    return [
                                      data.item.montos.anio_1
                                        ? _c(
                                            "b-input-group",
                                            {
                                              attrs: {
                                                prepend: "$",
                                                size: "sm",
                                              },
                                            },
                                            [
                                              _c("b-form-input", {
                                                attrs: {
                                                  readonly:
                                                    !_vm.isOperador ||
                                                    _vm.readOnly,
                                                },
                                                on: {
                                                  keypress: _vm.numbersOnly,
                                                  input: function ($event) {
                                                    return _vm.validateInput(
                                                      data.item.montos.anio_1,
                                                      "monto"
                                                    )
                                                  },
                                                  blur: function ($event) {
                                                    return _vm.formatInput(
                                                      data.item.montos.anio_1,
                                                      "monto"
                                                    )
                                                  },
                                                },
                                                model: {
                                                  value:
                                                    data.item.montos.anio_1
                                                      .monto,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      data.item.montos.anio_1,
                                                      "monto",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "data.item.montos.anio_1.monto",
                                                },
                                              }),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                    ]
                                  },
                                },
                                {
                                  key: "cell(anio_2)",
                                  fn: function (data) {
                                    return [
                                      data.item.montos.anio_2
                                        ? _c(
                                            "b-input-group",
                                            {
                                              attrs: {
                                                prepend: "$",
                                                size: "sm",
                                              },
                                            },
                                            [
                                              _c("b-form-input", {
                                                attrs: {
                                                  readonly:
                                                    !_vm.isOperador ||
                                                    _vm.readOnly,
                                                },
                                                on: {
                                                  keypress: _vm.numbersOnly,
                                                  input: function ($event) {
                                                    return _vm.validateInput(
                                                      data.item.montos.anio_2,
                                                      "monto"
                                                    )
                                                  },
                                                  blur: function ($event) {
                                                    return _vm.formatInput(
                                                      data.item.montos.anio_2,
                                                      "monto"
                                                    )
                                                  },
                                                },
                                                model: {
                                                  value:
                                                    data.item.montos.anio_2
                                                      .monto,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      data.item.montos.anio_2,
                                                      "monto",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "data.item.montos.anio_2.monto",
                                                },
                                              }),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                    ]
                                  },
                                },
                                {
                                  key: "cell(anio_3)",
                                  fn: function (data) {
                                    return [
                                      data.item.montos.anio_3
                                        ? _c(
                                            "b-input-group",
                                            {
                                              attrs: {
                                                prepend: "$",
                                                size: "sm",
                                              },
                                            },
                                            [
                                              _c("b-form-input", {
                                                attrs: {
                                                  readonly:
                                                    !_vm.isOperador ||
                                                    _vm.readOnly,
                                                },
                                                on: {
                                                  keypress: _vm.numbersOnly,
                                                  input: function ($event) {
                                                    return _vm.validateInput(
                                                      data.item.montos.anio_3,
                                                      "monto"
                                                    )
                                                  },
                                                  blur: function ($event) {
                                                    return _vm.formatInput(
                                                      data.item.montos.anio_3,
                                                      "monto"
                                                    )
                                                  },
                                                },
                                                model: {
                                                  value:
                                                    data.item.montos.anio_3
                                                      .monto,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      data.item.montos.anio_3,
                                                      "monto",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "data.item.montos.anio_3.monto",
                                                },
                                              }),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                    ]
                                  },
                                },
                                {
                                  key: "cell(anio_4)",
                                  fn: function (data) {
                                    return [
                                      data.item.montos.anio_4
                                        ? _c(
                                            "b-input-group",
                                            {
                                              attrs: {
                                                prepend: "$",
                                                size: "sm",
                                              },
                                            },
                                            [
                                              _c("b-form-input", {
                                                attrs: {
                                                  readonly:
                                                    !_vm.isOperador ||
                                                    _vm.readOnly,
                                                },
                                                on: {
                                                  keypress: _vm.numbersOnly,
                                                  input: function ($event) {
                                                    return _vm.validateInput(
                                                      data.item.montos.anio_4,
                                                      "monto"
                                                    )
                                                  },
                                                  blur: function ($event) {
                                                    return _vm.formatInput(
                                                      data.item.montos.anio_4,
                                                      "monto"
                                                    )
                                                  },
                                                },
                                                model: {
                                                  value:
                                                    data.item.montos.anio_4
                                                      .monto,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      data.item.montos.anio_4,
                                                      "monto",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "data.item.montos.anio_4.monto",
                                                },
                                              }),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                    ]
                                  },
                                },
                                {
                                  key: "cell(anio_5)",
                                  fn: function (data) {
                                    return [
                                      data.item.montos.anio_5
                                        ? _c(
                                            "b-input-group",
                                            {
                                              attrs: {
                                                prepend: "$",
                                                size: "sm",
                                              },
                                            },
                                            [
                                              _c("b-form-input", {
                                                attrs: {
                                                  readonly:
                                                    !_vm.isOperador ||
                                                    _vm.readOnly,
                                                },
                                                on: {
                                                  input: function ($event) {
                                                    return _vm.validateInput(
                                                      data.item.montos.anio_5,
                                                      "monto"
                                                    )
                                                  },
                                                  blur: function ($event) {
                                                    return _vm.formatInput(
                                                      data.item.montos.anio_5,
                                                      "monto"
                                                    )
                                                  },
                                                },
                                                model: {
                                                  value:
                                                    data.item.montos.anio_5
                                                      .monto,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      data.item.montos.anio_5,
                                                      "monto",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "data.item.montos.anio_5.monto",
                                                },
                                              }),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                    ]
                                  },
                                },
                                {
                                  key: "cell(anio_6)",
                                  fn: function (data) {
                                    return [
                                      data.item.montos.anio_6
                                        ? _c(
                                            "b-input-group",
                                            {
                                              attrs: {
                                                prepend: "$",
                                                size: "sm",
                                              },
                                            },
                                            [
                                              _c("b-form-input", {
                                                attrs: {
                                                  readonly:
                                                    !_vm.isOperador ||
                                                    _vm.readOnly,
                                                },
                                                on: {
                                                  input: function ($event) {
                                                    return _vm.validateInput(
                                                      data.item.montos.anio_6,
                                                      "monto"
                                                    )
                                                  },
                                                  blur: function ($event) {
                                                    return _vm.formatInput(
                                                      data.item.montos.anio_6,
                                                      "monto"
                                                    )
                                                  },
                                                },
                                                model: {
                                                  value:
                                                    data.item.montos.anio_6
                                                      .monto,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      data.item.montos.anio_6,
                                                      "monto",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "data.item.montos.anio_6.monto",
                                                },
                                              }),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              1323145269
                            ),
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.solucion.params.tipoBecaExtranjero ==
                  "ESTANCIA_TECNICA_JAPON"
                    ? _c(
                        "b-col",
                        { attrs: { md: "12" } },
                        [
                          _c("h4", { staticClass: "title mt-4 mb-4" }, [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "apeironGwApp.conciliacionExtranjeras.title-rubros-autorizar_periodo"
                                )
                              )
                            ),
                          ]),
                          _vm._v(" "),
                          _c("b-table", {
                            ref: "tableRubros",
                            staticClass: "table-conciliacion",
                            attrs: {
                              striped: "",
                              hover: "",
                              fields: _vm.fields,
                              items: _vm.solicitud.datos_conciliados.rubros,
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "cell()",
                                  fn: function (data) {
                                    return [
                                      _vm._v(
                                        "\n          " +
                                          _vm._s(
                                            _vm.getNombreRubro(
                                              data.item.concepto
                                            )
                                          ) +
                                          " - " +
                                          _vm._s(data.item.moneda) +
                                          "\n          "
                                      ),
                                      _vm._v(" "),
                                      data.item.montoTotal >= 0
                                        ? _c(
                                            "b-input-group",
                                            {
                                              attrs: {
                                                prepend: "$",
                                                size: "sm",
                                              },
                                            },
                                            [
                                              _c("b-form-input", {
                                                attrs: {
                                                  readonly:
                                                    !_vm.isOperador ||
                                                    _vm.readOnly,
                                                },
                                                on: {
                                                  keypress: _vm.numbersOnly,
                                                  input: function ($event) {
                                                    return _vm.validateInput(
                                                      data.item,
                                                      "montoTotal"
                                                    )
                                                  },
                                                  blur: function ($event) {
                                                    return _vm.formatInput(
                                                      data.item,
                                                      "montoTotal"
                                                    )
                                                  },
                                                },
                                                model: {
                                                  value: data.item.montoTotal,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      data.item,
                                                      "montoTotal",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "data.item.montoTotal",
                                                },
                                              }),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              1923992675
                            ),
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("b-col", [_c("div", { staticClass: "border-custom" })]),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "b-row",
            [
              _c("b-col", { attrs: { md: "12" } }, [
                _c("h4", { staticClass: "title mt-4 mb-4" }, [
                  _vm._v(
                    "\n        " +
                      _vm._s(
                        _vm.$t(
                          "apeironGwApp.conciliacionExtranjeras.title-ependientes-economicos"
                        )
                      ) +
                      "\n      "
                  ),
                ]),
              ]),
              _vm._v(" "),
              _vm.solicitud.datos_conciliados.dependientesEconomicos.length > 0
                ? _c(
                    "b-col",
                    { attrs: { md: "12" } },
                    [
                      _c(
                        "b-row",
                        _vm._l(
                          _vm.solicitud.datos_conciliados
                            .dependientesEconomicos,
                          function (item, i) {
                            return _c(
                              "b-col",
                              {
                                key: item.id,
                                attrs: { md: _vm.isOperador ? 6 : 12 },
                              },
                              [
                                _c(
                                  "b-card",
                                  { staticClass: "mb-3" },
                                  [
                                    _c("b-row", [
                                      _c("ul", { staticClass: "felx-2" }, [
                                        _c(
                                          "div",
                                          { staticClass: "left-felx" },
                                          [
                                            _c("b-card-text", [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "font-weight-bolder",
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(item.nombre) +
                                                      " " +
                                                      _vm._s(
                                                        item.primerApellido
                                                      ) +
                                                      " " +
                                                      _vm._s(
                                                        item.segundoApellido
                                                      )
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              item.parentesco
                                                ? _c("div", {
                                                    domProps: {
                                                      innerHTML: _vm._s(
                                                        item.parentesco.nombre
                                                      ),
                                                    },
                                                  })
                                                : _vm._e(),
                                            ]),
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        !_vm.isOperador
                                          ? _c(
                                              "div",
                                              {
                                                directives: [
                                                  {
                                                    name: "show",
                                                    rawName: "v-show",
                                                    value: !_vm.readOnly,
                                                    expression: "!readOnly",
                                                  },
                                                ],
                                                staticClass:
                                                  "right-felx card-btn",
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  [
                                                    _c(
                                                      "b-button",
                                                      {
                                                        attrs: {
                                                          variant:
                                                            "outline-primary",
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.editDependiente(
                                                              item,
                                                              i
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [
                                                        _c("span", {
                                                          staticClass:
                                                            "icon-editar",
                                                        }),
                                                        _vm._v(" "),
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "nombre-boton",
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "entity.action.edit"
                                                                )
                                                              )
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "b-button",
                                                      {
                                                        attrs: {
                                                          variant:
                                                            "outline-primary",
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.removeModal(
                                                              i
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [
                                                        _c("span", {
                                                          staticClass:
                                                            "icon-eliminar",
                                                        }),
                                                        _vm._v(" "),
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "nombre-boton",
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "entity.action.delete"
                                                                )
                                                              )
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    ),
                                                  ],
                                                  1
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                      ]),
                                    ]),
                                  ],
                                  1
                                ),
                              ],
                              1
                            )
                          }
                        ),
                        1
                      ),
                    ],
                    1
                  )
                : _c(
                    "b-col",
                    [
                      _c(
                        "b-card",
                        { staticClass: "mb-3" },
                        [
                          _c("b-card-text", [
                            _c(
                              "div",
                              { staticClass: "font-weight-bolder" },
                              [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(
                                      _vm.$t(
                                        "apeironGwApp.conciliacionExtranjeras.title-ependientes-economicos"
                                      )
                                    )
                                ),
                                _c(
                                  "b-badge",
                                  {
                                    staticClass: "float-right",
                                    attrs: { variant: "danger" },
                                  },
                                  [_vm._v("No")]
                                ),
                              ],
                              1
                            ),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
            ],
            1
          ),
          _vm._v(" "),
          !_vm.isOperador
            ? _c(
                "b-row",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.readOnly,
                      expression: "!readOnly",
                    },
                  ],
                  staticClass: "mt-4",
                },
                [
                  _c(
                    "b-col",
                    { attrs: { sm: "12", md: "6" } },
                    [
                      _c(
                        "b-form-group",
                        {
                          attrs: {
                            id: "dependientes-economicos-esExtranjero-form",
                            label:
                              _vm.$t(
                                "apeironGwApp.conciliacionExtranjeras.dependientes-economicos.esExtranjero.label"
                              ) + " *",
                            state: _vm.$v.dependientesNuevo.esExtranjero.$dirty
                              ? !_vm.$v.dependientesNuevo.esExtranjero.$error
                              : null,
                          },
                        },
                        [
                          _c("b-form-radio-group", {
                            class: _vm.valid == null ? "" : "is-invalid",
                            attrs: {
                              id: "dependientes-economicos-esExtranjero-id",
                              options: _vm.nacionalidadOptions,
                              state: _vm.$v.dependientesNuevo.esExtranjero
                                .$dirty
                                ? !_vm.$v.dependientesNuevo.esExtranjero.$error
                                : null,
                              disabled:
                                _vm.nacionalidadDisabled || _vm.readOnly,
                            },
                            on: {
                              change: function ($event) {
                                return _vm.changeNacionalidad($event)
                              },
                            },
                            model: {
                              value:
                                _vm.$v.dependientesNuevo.esExtranjero.$model,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.$v.dependientesNuevo.esExtranjero,
                                  "$model",
                                  $$v
                                )
                              },
                              expression:
                                "$v.dependientesNuevo.esExtranjero.$model",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { attrs: { sm: "12", md: "6" } },
                    [
                      !_vm.curpReadOnly
                        ? _c("input-text", {
                            attrs: {
                              id: "dependientes-economicos-curp-id",
                              label: _vm.$t(
                                "apeironGwApp.conciliacionExtranjeras.dependientes-economicos.curp.label"
                              ),
                              description: _vm.$t(
                                "apeironGwApp.conciliacionExtranjeras.dependientes-economicos.curp.description"
                              ),
                              placeholder: _vm.$t(
                                "apeironGwApp.conciliacionExtranjeras.dependientes-economicos.curp.placeholder"
                              ),
                              readonly: _vm.curpReadOnly || _vm.readOnly,
                              required: true,
                              valid: _vm.$v.dependientesNuevo.curp.$dirty
                                ? !_vm.$v.dependientesNuevo.curp.$error
                                : null,
                              validationsCommons: {
                                requiredValue:
                                  !_vm.$v.dependientesNuevo.curp.required,
                                requiredMessage: _vm.$t(
                                  "apeironGwApp.conciliacionExtranjeras.dependientes-economicos.curp.validations.required"
                                ),
                                minValue:
                                  !_vm.$v.dependientesNuevo.curp.minLength,
                                minMessage: _vm.$t(
                                  "apeironGwApp.conciliacionExtranjeras.dependientes-economicos.curp.validations.minMessage",
                                  { min: "1" }
                                ),
                                maxValue:
                                  !_vm.$v.dependientesNuevo.curp.maxLength,
                                maxMessage: _vm.$t(
                                  "apeironGwApp.conciliacionExtranjeras.dependientes-economicos.curp.validations.maxMessage",
                                  { max: "18" }
                                ),
                                regexValue: !_vm.$v.dependientesNuevo.curp.CURP,
                                regexMessage: _vm.$t(
                                  "apeironGwApp.conciliacionExtranjeras.dependientes-economicos.curp.validations.regexMessage"
                                ),
                              },
                            },
                            on: { input: _vm.capitalsOnly },
                            model: {
                              value: _vm.$v.dependientesNuevo.curp.$model,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.$v.dependientesNuevo.curp,
                                  "$model",
                                  $$v
                                )
                              },
                              expression: "$v.dependientesNuevo.curp.$model",
                            },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { attrs: { sm: "12", md: "4" } },
                    [
                      _c("input-text", {
                        attrs: {
                          id: "dependientes-economicos-nombre-id",
                          label: _vm.$t(
                            "apeironGwApp.conciliacionExtranjeras.dependientes-economicos.nombre.label"
                          ),
                          readonly: _vm.readOnly,
                          required: true,
                          valid: _vm.$v.dependientesNuevo.nombre.$dirty
                            ? !_vm.$v.dependientesNuevo.nombre.$error
                            : null,
                          validationsCommons: {
                            requiredValue:
                              !_vm.$v.dependientesNuevo.nombre.required,
                            requiredMessage: _vm.$t(
                              "apeironGwApp.conciliacionExtranjeras.dependientes-economicos.nombre.validations.required"
                            ),
                            minValue:
                              !_vm.$v.dependientesNuevo.nombre.minLength,
                            minMessage: _vm.$t(
                              "apeironGwApp.conciliacionExtranjeras.dependientes-economicos.nombre.validations.minMessage",
                              { min: "2" }
                            ),
                            maxValue:
                              !_vm.$v.dependientesNuevo.nombre.maxLength,
                            maxMessage: _vm.$t(
                              "apeironGwApp.conciliacionExtranjeras.dependientes-economicos.nombre.validations.maxMessage",
                              { max: "50" }
                            ),
                          },
                          maxCaracteres: 50,
                        },
                        model: {
                          value: _vm.$v.dependientesNuevo.nombre.$model,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.$v.dependientesNuevo.nombre,
                              "$model",
                              $$v
                            )
                          },
                          expression: "$v.dependientesNuevo.nombre.$model",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { attrs: { sm: "12", md: "4" } },
                    [
                      _c("input-text", {
                        attrs: {
                          id: "dependientes-economicos.apellido-paterno-id",
                          label: _vm.$t(
                            "apeironGwApp.conciliacionExtranjeras.dependientes-economicos.apellido-paterno.label"
                          ),
                          readonly: _vm.readOnly,
                          required: true,
                          valid: _vm.$v.dependientesNuevo.primerApellido.$dirty
                            ? !_vm.$v.dependientesNuevo.primerApellido.$error
                            : null,
                          validationsCommons: {
                            requiredValue:
                              !_vm.$v.dependientesNuevo.primerApellido.required,
                            requiredMessage: _vm.$t(
                              "apeironGwApp.conciliacionExtranjeras.dependientes-economicos.apellido-paterno.validations.required"
                            ),
                            minValue:
                              !_vm.$v.dependientesNuevo.primerApellido
                                .minLength,
                            minMessage: _vm.$t(
                              "apeironGwApp.conciliacionExtranjeras.dependientes-economicos.apellido-paterno.validations.minMessage",
                              {
                                min: "2",
                              }
                            ),
                            maxValue:
                              !_vm.$v.dependientesNuevo.primerApellido
                                .maxLength,
                            maxMessage: _vm.$t(
                              "apeironGwApp.conciliacionExtranjeras.dependientes-economicos.apellido-paterno.validations.maxMessage",
                              {
                                max: "50",
                              }
                            ),
                          },
                          maxCaracteres: 50,
                        },
                        model: {
                          value: _vm.$v.dependientesNuevo.primerApellido.$model,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.$v.dependientesNuevo.primerApellido,
                              "$model",
                              $$v
                            )
                          },
                          expression:
                            "$v.dependientesNuevo.primerApellido.$model",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { attrs: { sm: "12", md: "4" } },
                    [
                      _c("input-text", {
                        attrs: {
                          id: "dependientes-economicos.apellido-materno-id",
                          label: _vm.$t(
                            "apeironGwApp.conciliacionExtranjeras.dependientes-economicos.apellido-materno.label"
                          ),
                          readonly: _vm.readOnly,
                          required: true,
                          valid: _vm.$v.dependientesNuevo.segundoApellido.$dirty
                            ? !_vm.$v.dependientesNuevo.segundoApellido.$error
                            : null,
                          validationsCommons: {
                            requiredValue:
                              !_vm.$v.dependientesNuevo.segundoApellido
                                .required,
                            requiredMessage: _vm.$t(
                              "apeironGwApp.conciliacionExtranjeras.dependientes-economicos.apellido-materno.validations.required"
                            ),
                            minValue:
                              !_vm.$v.dependientesNuevo.segundoApellido
                                .minLength,
                            minMessage: _vm.$t(
                              "apeironGwApp.conciliacionExtranjeras.dependientes-economicos.apellido-materno.validations.minMessage",
                              {
                                min: "2",
                              }
                            ),
                            maxValue:
                              !_vm.$v.dependientesNuevo.segundoApellido
                                .maxLength,
                            maxMessage: _vm.$t(
                              "apeironGwApp.conciliacionExtranjeras.dependientes-economicos.apellido-materno.validations.maxMessage",
                              {
                                max: "50",
                              }
                            ),
                          },
                          maxCaracteres: 50,
                        },
                        model: {
                          value:
                            _vm.$v.dependientesNuevo.segundoApellido.$model,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.$v.dependientesNuevo.segundoApellido,
                              "$model",
                              $$v
                            )
                          },
                          expression:
                            "$v.dependientesNuevo.segundoApellido.$model",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { attrs: { sm: "12", md: "4" } },
                    [
                      _c(
                        "b-form-group",
                        {
                          attrs: {
                            label:
                              _vm.$t(
                                "apeironGwApp.conciliacionExtranjeras.dependientes-economicos.nacimiento.label"
                              ) + " *",
                          },
                        },
                        [
                          _c("v-date-picker", {
                            attrs: { locale: _vm.locale },
                            on: { input: _vm.onFechaSeleccionada },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function ({ inputValue, inputEvents }) {
                                    return [
                                      _c(
                                        "input",
                                        _vm._g(
                                          {
                                            staticClass: "custom-date-picker",
                                            domProps: { value: inputValue },
                                          },
                                          inputEvents
                                        )
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              298704136
                            ),
                            model: {
                              value:
                                _vm.$v.dependientesNuevo.fechaNacimiento.$model,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.$v.dependientesNuevo.fechaNacimiento,
                                  "$model",
                                  $$v
                                )
                              },
                              expression:
                                "$v.dependientesNuevo.fechaNacimiento.$model",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { attrs: { sm: "12", md: "4" } },
                    [
                      _c("input-select-one", {
                        attrs: {
                          id: "dependientes-economicos-parentesco-id",
                          label: _vm.$t(
                            "apeironGwApp.conciliacionExtranjeras.dependientes-economicos.parentesco.label"
                          ),
                          readonly: _vm.readOnly,
                          required: true,
                          options: _vm.parentescoOption,
                          valid: _vm.$v.dependientesNuevo.parentesco.$dirty
                            ? !_vm.$v.dependientesNuevo.parentesco.$error
                            : null,
                          validationsCommons: {
                            requiredValue:
                              !_vm.$v.dependientesNuevo.parentesco.required,
                            requiredMessage: _vm.$t(
                              "apeironGwApp.conciliacionExtranjeras.dependientes-economicos.parentesco.validations.required"
                            ),
                            regexMessage: _vm.$t(
                              "apeironGwApp.conciliacionExtranjeras.dependientes-economicos.parentesco.validations.regexMessage"
                            ),
                          },
                        },
                        on: { change: _vm.sexoParentescoChange },
                        model: {
                          value: _vm.$v.dependientesNuevo.parentesco.$model,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.$v.dependientesNuevo.parentesco,
                              "$model",
                              $$v
                            )
                          },
                          expression: "$v.dependientesNuevo.parentesco.$model",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { attrs: { sm: "12", md: "4" } },
                    [
                      _c(
                        "b-form-group",
                        {
                          attrs: {
                            id: "dependientes-economicos-sexo-form",
                            label:
                              _vm.$t(
                                "apeironGwApp.conciliacionExtranjeras.dependientes-economicos.sexo.label"
                              ) + " *",
                            state: _vm.$v.dependientesNuevo.sexo.$dirty
                              ? !_vm.$v.dependientesNuevo.sexo.$error
                              : null,
                          },
                        },
                        [
                          _c("b-form-radio-group", {
                            class: _vm.valid == null ? "" : "is-invalid",
                            attrs: {
                              id: "dependientes-economicos-sexo-id",
                              options: _vm.sexoOptions,
                              state: _vm.$v.dependientesNuevo.sexo.$dirty
                                ? !_vm.$v.dependientesNuevo.sexo.$error
                                : null,
                              disabled: _vm.sexoDisabled || _vm.readOnly,
                            },
                            model: {
                              value: _vm.$v.dependientesNuevo.sexo.$model,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.$v.dependientesNuevo.sexo,
                                  "$model",
                                  $$v
                                )
                              },
                              expression: "$v.dependientesNuevo.sexo.$model",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("b-col", { attrs: { md: "12" } }, [
                    !_vm.readOnly
                      ? _c(
                          "div",
                          { staticClass: "float-right" },
                          [
                            _vm.removeIndex !== null
                              ? _c(
                                  "b-button",
                                  {
                                    attrs: { variant: "outline-primary" },
                                    on: { click: _vm.cancelaDependiente },
                                  },
                                  [
                                    _c("span", {
                                      domProps: {
                                        textContent: _vm._s(
                                          _vm.$t(
                                            "apeironGwApp.conciliacionExtranjeras.dependientes-economicos.cancel.label"
                                          )
                                        ),
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "icon-cerrar" }),
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "b-button",
                              {
                                attrs: { variant: "primary" },
                                on: { click: _vm.addDependiente },
                              },
                              [
                                _c("span", {
                                  domProps: {
                                    textContent: _vm._s(
                                      _vm.$t(
                                        "apeironGwApp.conciliacionExtranjeras.dependientes-economicos.save.label"
                                      )
                                    ),
                                  },
                                }),
                                _vm._v(" "),
                                _c("font-awesome-icon", {
                                  staticClass: "mr-2",
                                  attrs: { icon: "save" },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                  ]),
                  _vm._v(" "),
                  _c("b-col", [_c("div", { staticClass: "border-custom" })]),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "b-row",
            [
              _vm.isOperador
                ? _c("b-col", [_c("div", { staticClass: "border-custom" })])
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _c("comentarios-ajuste", {
            attrs: {
              id: "comentarios-ajuste-id",
              solicitudId: _vm.solicitud.id,
              solicitud: _vm.solicitud,
              isOperador: _vm.isOperador,
              readOnly: _vm.readOnly,
            },
            on: {
              comentarioSaved: function ($event) {
                return _vm.updateAjustesSolicitados()
              },
            },
          }),
          _vm._v(" "),
          _c(
            "b-row",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.readOnly,
                  expression: "!readOnly",
                },
              ],
            },
            [
              _c(
                "b-col",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.readOnly,
                      expression: "!readOnly",
                    },
                  ],
                  attrs: { md: "12" },
                },
                [
                  !_vm.isOperador
                    ? _c(
                        "b-alert",
                        {
                          staticClass: "mt-4 mb-4",
                          attrs: { show: "", variant: "primary" },
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "apeironGwApp.conciliacionExtranjeras.dependientes-economicos.alerts.actualizar-comentarios"
                              )
                            )
                          ),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.isOperador
                    ? _c(
                        "b-form-checkbox",
                        {
                          attrs: {
                            name: "check-button",
                            button: "",
                            "button-variant": _vm.confirmo
                              ? "success"
                              : "warning",
                            disabled: _vm.disabledConfirmo,
                          },
                          model: {
                            value: _vm.confirmo,
                            callback: function ($$v) {
                              _vm.confirmo = $$v
                            },
                            expression: "confirmo",
                          },
                        },
                        [
                          _c("div", [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "apeironGwApp.conciliacionExtranjeras.dependientes-economicos.alerts.confirma-informacion"
                                )
                              )
                            ),
                          ]),
                          _vm._v(" "),
                          _vm.confirmo
                            ? _c("b", [
                                _vm._v(
                                  " (" +
                                    _vm._s(
                                      _vm.$t(
                                        "apeironGwApp.conciliacionExtranjeras.confirma.si"
                                      )
                                    ) +
                                    ") "
                                ),
                              ])
                            : _c("b", [
                                _vm._v(
                                  " (" +
                                    _vm._s(
                                      _vm.$t(
                                        "apeironGwApp.conciliacionExtranjeras.confirma.no"
                                      )
                                    ) +
                                    ") "
                                ),
                              ]),
                        ]
                      )
                    : _vm._e(),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-col",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.readOnly,
                      expression: "!readOnly",
                    },
                  ],
                  attrs: { md: "12" },
                },
                [
                  _c(
                    "div",
                    { staticClass: "float-right mt-4" },
                    [
                      !_vm.isOperador
                        ? _c(
                            "b-button",
                            {
                              attrs: {
                                variant: "primary",
                                disabled: !_vm.confirmo,
                              },
                              on: { click: _vm.confirmaDatos },
                            },
                            [
                              _c("span", {
                                domProps: {
                                  textContent: _vm._s(
                                    _vm.$t("entity.action.save")
                                  ),
                                },
                              }),
                              _vm._v(" "),
                              _c("font-awesome-icon", {
                                staticClass: "mr-2",
                                attrs: { icon: "save" },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "b-col",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.readOnly,
                      expression: "!readOnly",
                    },
                  ],
                  attrs: { md: "12" },
                },
                [
                  _c(
                    "div",
                    { staticClass: "float-right mt-4" },
                    [
                      _vm.isOperador
                        ? _c(
                            "b-button",
                            {
                              attrs: { variant: "primary" },
                              on: { click: _vm.confirmaDatos },
                            },
                            [
                              _c("span", {
                                domProps: {
                                  textContent: _vm._s(
                                    _vm.$t("entity.action.save")
                                  ),
                                },
                              }),
                              _vm._v(" "),
                              _c("font-awesome-icon", {
                                staticClass: "mr-2",
                                attrs: { icon: "save" },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-modal",
            {
              ref: "removeDependiente",
              attrs: {
                id: "removeDependiente",
                title: _vm.$t(
                  "apeironGwApp.conciliacionExtranjeras.confirmacion"
                ),
              },
              on: { ok: _vm.deleteDependiente, hide: _vm.cancelModal },
            },
            [
              _c("p", { staticClass: "my-4" }, [
                _c("span", [
                  _vm._v(
                    _vm._s(
                      _vm.$t(
                        "apeironGwApp.conciliacionExtranjeras.dependientes-economicos.alerts.elimina"
                      )
                    )
                  ),
                ]),
              ]),
            ]
          ),
          _vm._v(" "),
          _c(
            "b-modal",
            {
              ref: "changeDependiente",
              attrs: {
                id: "changeDependiente",
                title: _vm.$t(
                  "apeironGwApp.conciliacionExtranjeras.informativo"
                ),
                "ok-only": "",
              },
            },
            [
              _c("p", { staticClass: "my-4" }, [
                _c("span", [
                  _vm._v(
                    _vm._s(
                      _vm.$t(
                        "apeironGwApp.conciliacionExtranjeras.dependientes-economicos.alerts.dependiente-modifica"
                      )
                    )
                  ),
                ]),
              ]),
            ]
          ),
          _vm._v(" "),
          _c(
            "b-modal",
            {
              ref: "montosInvalidos",
              attrs: {
                id: "montosInvalidos",
                title: "Montos inválidos",
                "ok-only": "",
                "ok-title": "Entendido",
                centered: "",
                size: "lg",
              },
            },
            [
              _c(
                "div",
                [
                  _c("p", { staticClass: "mb-4" }, [
                    _vm._v(
                      "\n        Se detectaron inconsistencias en los montos de\n        "
                    ),
                    _c("strong", [_vm._v("MANUTENCIÓN")]),
                    _vm._v(".\n      "),
                  ]),
                  _vm._v(" "),
                  _vm._l(_vm.erroresMontos, function (error, index) {
                    return _c(
                      "div",
                      { key: index, staticClass: "monto-error mb-4" },
                      [
                        _c("div", { staticClass: "monto-error-header" }, [
                          _vm._v(
                            "MANUTENCIÓN — " +
                              _vm._s(error.anio || error.periodo)
                          ),
                        ]),
                        _vm._v(" "),
                        error.montoMensual !== undefined
                          ? _c("div", { staticClass: "monto-error-body" }, [
                              _c("div", { staticClass: "monto-row" }, [
                                _c("span", [_vm._v("Monto mensual:")]),
                                _vm._v(" "),
                                _c("strong", [
                                  _vm._v(
                                    "\n              $" +
                                      _vm._s(
                                        Number(
                                          error.montoMensual
                                        ).toLocaleString("es-MX", {
                                          minimumFractionDigits: 2,
                                          maximumFractionDigits: 2,
                                        })
                                      ) +
                                      "\n            "
                                  ),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "monto-row" }, [
                                _c("span", [_vm._v("Meses del periodo:")]),
                                _vm._v(" "),
                                _c("strong", [
                                  _vm._v(_vm._s(error.mesesPeriodo)),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "monto-row" }, [
                                _c("span", [_vm._v("Monto registrado:")]),
                                _vm._v(" "),
                                _c("strong", { staticClass: "text-danger" }, [
                                  _vm._v(
                                    "\n              $" +
                                      _vm._s(
                                        Number(
                                          error.montoRegistrado
                                        ).toLocaleString("es-MX", {
                                          minimumFractionDigits: 2,
                                          maximumFractionDigits: 2,
                                        })
                                      ) +
                                      "\n            "
                                  ),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "monto-row" }, [
                                _c("span", [_vm._v("Debe registrar:")]),
                                _vm._v(" "),
                                _c("strong", { staticClass: "text-success" }, [
                                  _vm._v(
                                    "\n              $" +
                                      _vm._s(
                                        Number(
                                          error.montoEsperado
                                        ).toLocaleString("es-MX", {
                                          minimumFractionDigits: 2,
                                          maximumFractionDigits: 2,
                                        })
                                      ) +
                                      "\n            "
                                  ),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "monto-row" }, [
                                _c("span", [_vm._v("Diferencia:")]),
                                _vm._v(" "),
                                _c("strong", { staticClass: "text-danger" }, [
                                  _vm._v(
                                    "\n              $" +
                                      _vm._s(
                                        Number(error.diferencia).toLocaleString(
                                          "es-MX",
                                          {
                                            minimumFractionDigits: 2,
                                            maximumFractionDigits: 2,
                                          }
                                        )
                                      ) +
                                      "\n            "
                                  ),
                                ]),
                              ]),
                            ])
                          : _c("div", { staticClass: "monto-error-body" }, [
                              _vm._v(
                                "\n          " +
                                  _vm._s(error.mensaje) +
                                  "\n        "
                              ),
                            ]),
                      ]
                    )
                  }),
                  _vm._v(" "),
                  _c(
                    "b-alert",
                    {
                      staticClass: "mb-0",
                      attrs: { show: "", variant: "warning" },
                    },
                    [
                      _c("strong", [_vm._v("¿Cómo corregirlo?")]),
                      _vm._v(" "),
                      _c("br"),
                      _vm._v(
                        "\n        Regresa a la sección de rubros y utiliza\n        "
                      ),
                      _c("strong", [_vm._v("“Recalcular”")]),
                      _vm._v(" antes de continuar.\n      "),
                    ]
                  ),
                ],
                2
              ),
            ]
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }